import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { BackButton } from '../../../../components/UI/ComponentsUI';
import { translate, formatData, enumText } from '../../../../utils/util';
import { ENUMS } from '../../../../utils/constants';

const LogDetail = (props) => {
    const item = props.log || {};

    return (
        <div>
            <BackButton {...props} />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '5px' }}>
                        <div className="row" style={{ marginBottom: '5' }}>
                            <div className="subtitle col s12" style={{ padding: '0px' }}>
                                <span className="field f-1r">{translate('log-details', 'stock')}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field no-padding col s6">
                                <span className="field f-1r">{formatData(item?.createdOn)}</span>
                            </div>
                            <div className="input-field no-padding col s5">
                                <span className="field f-1r"> {translate(enumText(ENUMS.eDiffusionLogStatus, item.status || ''))}</span>
                                <label className="active">{translate('stock:diffusion-log-status')}</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field no-padding col s6">
                                <span className="field f-1r">{item.partNumber}</span>
                                <label className="active">{translate('stock:diffusion-log-partnumber')}</label>
                            </div>
                            <div className="input-field no-padding col s5">
                                <span className="field f-1r">{item.quantity}</span>
                                <label className="active">{translate('stock:diffusion-log-qtd')}</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field no-padding col s4">
                                <span className="field f-1r">{item.chassi}</span>
                                <label className="active">Chassi</label>
                            </div>
                            <div className="input-field no-padding col s4">
                                <span className="field f-1r">{item.vin}</span>
                                <label className="active">VIN</label>
                            </div>
                            <div className="input-field no-padding col s3">
                                <span className="field f-1r">{item.cis}</span>
                                <label className="active">CIS</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field no-padding col s12">
                                <span className="field f-1r">{item.message ?? "-"}</span>
                                <label className="active">{translate('stock:diffusion-log-message')}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        log: state.stockReducer.diffusionLog
    };
};

const mapDispatchToProps = () => {
    return {
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LogDetail)));
